var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"none"},attrs:{"id":_vm.areaId}},_vm._l((_vm.labels),function(l,i){return _c('div',{key:'il' + i,staticStyle:{"page-break-after":"always","width":"80mm","height":"60mm","overflow":"hidden"}},[_c('inbound-label',{attrs:{"row":l.row,"location":l.location,"waybill":l.waybill}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }